import React, { useEffect, useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { DownOutlined, ScanOutlined, ClearOutlined } from '@ant-design/icons';
import {
  Col,
  Row,
  Tabs,
  Button,
  Modal,
  Select,
  Tooltip,
  Dropdown,
  Menu,
  Space,
  Spin,
  message
} from 'antd';
//Components
import Wait4Me from '../../../components/Wait4Me';
import BreadCrumb from '../../../components/BreadCrumb';
import NoDataToDisplay from '../../../components/NoDataToDisplay';
import NSAlertDetailHits from './component/NSAlertDetailHits';
import NSAlertDetailTopPannel from './component/NSAlertDetailTopPannel';
import NSAlertDetailPartyIdentity from './component/NSAlertDetailPartyIdentity';
import { ROUTE_AMLS_SMART_SCREENING } from '../../../pages/constants/globalConstants';
import {
  ALERT_SOURCEID_MAPPING,
  GLOBAL_SETTINGS_SOURCE_MAPPING,
  DDMMYYYYHHMMTimeFormatForFileDownload
} from '../../../util/GlobalConstant';

import style from './index.scss';
import { cloneDeep, get, set, union } from 'lodash';
import FilterDropdown from '../onDemandScreening/alertList/FilterDropDown';
import { StyledAlertDetailsFilters } from '../onDemandScreening/styled';

const { Option } = Select;
const { confirm } = Modal;

export const AlertDetail = ({
  apiActions,
  settings,
  runInstance,
  match,
  alertId,
  isEmbedded = false,
  alertMetaSuffix,
  alertMetaPrefix,
  authentication,
  nsInvestigation,
  isFromNameScreening,
  amlsCommon
}) => {
  const [entityIndex, setEntityIndex] = useState(0);
  const [currentSource, setCurrentSource] = useState(null);
  const [selectedForCompare, setSelectedForCompare] = useState([]);
  const [totalDiff, setTotalDiff] = useState([]);
  const [isCompared, setIsCompared] = useState(false);
  const [whiteListedSelect, setWhiteListedSelect] = useState([]);
  const [alertDetails, setAlertDetails] = useState({});
  const [filteredAlertDetails, setFilteredAlertDetails] = useState(null);
  const [filters, setFilters] = useState({
    hitLevel: undefined,
    nameOfWatchlist: undefined,
    watchlistCategory: undefined,
    watchlistSubCategory: undefined
  });
  const [filterData, setFilterData] = useState({
    nameOfWatchlist: [],
    watchlistCategory: [],
    watchlistSubCategory: []
  });

  const {
    navigateTo,
    getNSGlobalSettingsPageInfo,
    getNSAlertDetailsListData,
    sendToCMAlerts,
    downloadSelectedAlerts,
    getAMLSCommonAlertDetails,
    getAMLSCommonAlertPartyIdentity,
    fetchAMLSAlertLevel
  } = apiActions;

  const {
    alertDetails: commomAlertDetails,
    alertPartyIdentity,
    alertLevelConfigs
  } = amlsCommon;
  const { sendToCM: sendToCMDetails } = nsInvestigation;
  const { data: alertLevels } = alertLevelConfigs;

  const { alertDetails: runInstanceAlerts, hitsUserFeedback } = runInstance;
  const { TabPane } = Tabs;

  useEffect(() => {
    const filteredEntitiesWithHits = runInstanceAlerts?.entities?.filter(
      (entity) => entity.hits && entity.hits.length
    );
    const alertDetailsWithHits = {
      ...runInstanceAlerts,
      entities: cloneDeep(filteredEntitiesWithHits)
    };
    setAlertDetails(cloneDeep(alertDetailsWithHits));
    setFilteredAlertDetails(cloneDeep(alertDetailsWithHits));
    if (Object.keys(alertDetailsWithHits).length > 0) {
      const allAlerts =
        get(cloneDeep(alertDetailsWithHits), `entities.${entityIndex}`)?.hits ||
        [];
      const allWatchListName =
        allAlerts
          .map((a) => a.nameOfWatchlist)
          .filter((a, i, b) => b.indexOf(a) === i) || [];
      const allWatchListCategory =
        allAlerts
          .map((a) => a.watchlistCategory)
          .filter((a, i, b) => b.indexOf(a) === i) || [];
      const allWatchListSubCategory =
        allAlerts
          .map((a) => a.watchlistSubCategory)
          .filter((a, i, b) => b.indexOf(a) === i) || [];
      setFilterData({
        nameOfWatchlist: allWatchListName,
        watchlistCategory: allWatchListCategory,
        watchlistSubCategory: allWatchListSubCategory
      });
    }
  }, [runInstanceAlerts]);

  useEffect(() => {
    const allAlerts =
      get(cloneDeep(filteredAlertDetails), `entities.${entityIndex}`)?.hits ||
      [];
    const filteredData = filterAlertData(allAlerts);
    const filteredAlerts = cloneDeep(filteredAlertDetails);
    set(filteredAlerts, `entities[${entityIndex}].hits`, filteredData);
    setFilteredAlertDetails({ ...filteredAlerts });
  }, [filters]);

  const filterAlertData = (data) => {
    if (
      !filters.watchlistCategory &&
      !filters.watchlistSubCategory &&
      !filters.nameOfWatchlist &&
      !filters.hitLevel
    ) {
      return data;
    } else {
      return data.filter(
        (item) =>
          (!filters.watchlistCategory ||
            item.watchlistCategory === filters.watchlistCategory) &&
          (!filters.watchlistSubCategory ||
            item.watchlistSubCategory === filters.watchlistSubCategory) &&
          (!filters.nameOfWatchlist ||
            item.nameOfWatchlist === filters.nameOfWatchlist) &&
          (!filters.hitLevel || item.hitLevel === filters.hitLevel)
      );
    }
  };

  useEffect(() => {
    //This is to check if filtered options available when isWhitelisted selection does not exist.
    const filtersApplied = Object.values(filters).filter(
      (value) => value !== undefined && value !== null
    );
    if (
      alertDetails?.entities?.length > 0 &&
      (filtersApplied.length || whiteListedSelect.length)
    ) {
      const allAlerts = get(
        cloneDeep(alertDetails),
        `entities.${entityIndex}.hits`,
        []
      );
      const filteredItems = whiteListedSelect.length
        ? allAlerts.filter((hit) =>
            whiteListedSelect.includes(hit?.isWhitelisted?.toString())
          )
        : allAlerts;
      const finalFilteredItems = filterAlertData(filteredItems);
      const filteredAlerts = cloneDeep(alertDetails);
      set(filteredAlerts, `entities[${entityIndex}].hits`, finalFilteredItems);
      setFilteredAlertDetails({ ...filteredAlerts });
    } else {
      setFilteredAlertDetails(cloneDeep(alertDetails));
    }
  }, [whiteListedSelect, filters]);

  useEffect(() => {
    getAMLSCommonAlertDetails({ alertId: alertId || match.params.id });
    getNSAlertDetailsListData({ id: alertId || match.params.id });
    resetHitsToCompare();

    if (!alertLevels?.length) {
      fetchAMLSAlertLevel();
    }
  }, [alertId]);

  useEffect(() => {
    if (alertDetails) {
      const { alertSourceId } = alertDetails || {};
      const source = ALERT_SOURCEID_MAPPING[alertSourceId];
      setCurrentSource(source);
      if (alertSourceId && ALERT_SOURCEID_MAPPING[alertSourceId] != 'TS') {
        getAMLSCommonAlertPartyIdentity({
          alertId: alertId || match.params.id
        });
      }
    }
  }, [alertDetails]);

  useEffect(() => {
    if (currentSource) {
      getNSGlobalSettingsPageInfo({
        pageId: GLOBAL_SETTINGS_SOURCE_MAPPING[currentSource].pageId
      });
    }
  }, [currentSource]);

  const getGSConfig = (q) => {
    if (settings?.nsSetting?.data?.uiWidgetGroups) {
      const groups = settings.nsSetting.data.uiWidgetGroups;
      return groups
        .find((g) => g.widgetGroupId === q.widgetGroupId)
        ?.widgets.find((w) => w.widgetId === q.widgetId);
    }
    return {};
  };

  const topPanelWidgetId =
    GLOBAL_SETTINGS_SOURCE_MAPPING?.[currentSource]?.['topPanelWidgetId'];
  const topPanelWidgetGoupId =
    GLOBAL_SETTINGS_SOURCE_MAPPING?.[currentSource]?.['topPanelWidgetGoupId'];
  const identityWidgetId =
    GLOBAL_SETTINGS_SOURCE_MAPPING?.[currentSource]?.['identityWidgetId'];
  const identityAndhitsExplainabilityWidgetGroupId =
    GLOBAL_SETTINGS_SOURCE_MAPPING?.[currentSource]?.[
      'identityAndhitsExplainabilityWidgetGroupId'
    ];
  const hitsExplainabilityWidgetId =
    GLOBAL_SETTINGS_SOURCE_MAPPING?.[currentSource]?.[
      'hitsExplainabilityWidgetId'
    ];

  const tabChangeHandler = (tab) => {
    setEntityIndex(tab);
    setFilters({
      hitLevel: undefined,
      nameOfWatchlist: undefined,
      watchlistCategory: undefined,
      watchlistSubCategory: undefined
    });
    //reset hits selection on entity change
    resetHitsToCompare();
  };

  const resetHitsToCompare = () => {
    setTotalDiff([]);
    setIsCompared(false);
    setSelectedForCompare([]);
  };

  const compareTwoHits = () => {
    if (isCompared) {
      //Once compared reset
      resetHitsToCompare();
    } else {
      const allAlerts = get(alertDetails, `entities.${entityIndex}`).hits || [];
      const filteredItems = allAlerts.filter((a) =>
        selectedForCompare.some((s) => s === a.hitId)
      );

      const allObjKeys = union([
        ...Object.keys(filteredItems[0]),
        ...Object.keys(filteredItems[1])
      ]);

      const diffInFields = allObjKeys.filter((field) => {
        if (field === 'hitId') {
          return false;
        }
        const obj1Value = filteredItems[0][field];
        const obj2Value = filteredItems[1][field];
        if (obj1Value === undefined || obj2Value === undefined) {
          return true;
        }
        if (typeof obj2Value === 'string') {
          return obj2Value.toLowerCase() !== obj1Value.toLowerCase();
        }
        return obj2Value !== obj1Value;
      });

      setTotalDiff(diffInFields);
      setIsCompared(true);
    }
  };

  const sendToCM = () => {
    confirm({
      title: `Send to CM`,
      content: `Are you sure you want to generate an alert in CM?`,
      centered: true,
      okText: 'Confirm',
      width: 500,
      okButtonProps: {
        style: {
          backgroundColor: '#2B73E0'
        }
      },
      onOk: () => {
        sendToCMAlerts({
          ids: [alertId || match.params.id],
          isFromAlertList: false
        });
      }
    });
  };

  const downloadAlerts = () => {
    downloadSelectedAlerts({
      ids: [alertId || match.params.id],
      fileName: `Alert_Details_Page__${moment().format(
        DDMMYYYYHHMMTimeFormatForFileDownload
      )}.csv`
    });
  };

  const takeActionMenu = (
    <Menu onClick={() => {}} disabled={!alertDetails?.alertId}>
      <Menu.Item key="1" onClick={() => downloadAlerts()}>
        Download alert
      </Menu.Item>
      {isFromNameScreening && (
        <Menu.Item
          key="2"
          disabled={commomAlertDetails?.data?.isSentToCm}
          onClick={() => sendToCM()}>
          Send to CM
        </Menu.Item>
      )}
    </Menu>
  );

  const onSelectForComparision = (hitId) => {
    if (selectedForCompare.includes(hitId)) {
      setSelectedForCompare([...selectedForCompare.filter((f) => f !== hitId)]);
      setTotalDiff([]);
      setIsCompared(false);
    } else if (selectedForCompare.length === 2) {
      return message.error('Only 2 hits can be added to compare');
    } else {
      setSelectedForCompare([...selectedForCompare, hitId]);
    }
  };

  const onFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value
    }));
  };

  const isWhitelistedGlobally = get(
    alertDetails,
    `entities.${entityIndex}.isWhitelisted`
  );

  const whitelistDisableHoverText =
    'Filter disabled, as Entity is globally whitelisted';

  return (
    <Spin spinning={sendToCMDetails.isLoading}>
      <Row>
        <Col span={24}>
          <div className={style.wrapper}>
            {settings?.nsSetting?.isLoading || runInstance?.isLoading ? (
              <div className={style.loadingWrapper}>
                <Wait4Me />
              </div>
            ) : (
              <React.Fragment>
                <div>
                  <div className={style.head}>
                    {isEmbedded !== true && (
                      <BreadCrumb
                        crumbs={[
                          {
                            label: 'Run Instance',
                            linkTo: `${ROUTE_AMLS_SMART_SCREENING}/runInstance?tab=2`
                          },
                          { label: 'Alert View' }
                        ]}
                      />
                    )}
                    {alertDetails.error === undefined ? (
                      <NSAlertDetailTopPannel
                        isEmbedded={isEmbedded}
                        GS={getGSConfig({
                          widgetGroupId: topPanelWidgetGoupId,
                          widgetId: topPanelWidgetId
                        })}
                        navigateTo={navigateTo}
                        data={alertDetails}
                        alertMetaPrefix={alertMetaPrefix}
                        alertMetaSuffix={alertMetaSuffix}
                      />
                    ) : (
                      <div className={style.noDataToDisplayWrapper}>
                        <NoDataToDisplay />
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  {alertDetails?.entities?.length ? (
                    <div className={style.alertDetailTabs}>
                      <Tabs
                        defaultActiveKey={entityIndex}
                        onChange={tabChangeHandler}>
                        {alertDetails?.entities?.map((entity, index) => (
                          <TabPane
                            tab={`Entity ${index + 1}`}
                            key={index}></TabPane>
                        ))}
                      </Tabs>
                    </div>
                  ) : null}
                </div>
                {alertDetails.error === undefined ? (
                  <div className={style.alertDetailBody}>
                    <div className={style.alertHeader}>
                      <h4>Entity Identity and Score Explainability</h4>
                      <div className="filters">
                        <FilterDropdown
                          placement="bottomRight"
                          className={`filters-icon`}>
                          <StyledAlertDetailsFilters
                            filters={filters}
                            filterData={filterData}
                            onChange={onFilterChange}
                            alertLevels={alertLevels}
                          />
                          <></>
                        </FilterDropdown>
                        <div className="select-filters">
                          <label>Is Whitelisted</label>
                          <Tooltip
                            title={
                              isWhitelistedGlobally
                                ? whitelistDisableHoverText
                                : ''
                            }>
                            <Select
                              mode="multiple"
                              allowClear
                              showSearch={false}
                              placeholder={`Please Select`}
                              onChange={(e) => setWhiteListedSelect(e)}
                              value={whiteListedSelect}
                              disabled={isWhitelistedGlobally}
                              style={{ minWidth: '175px', maxWidth: '325px' }}>
                              <Option value="true">True</Option>
                              <Option value="false">False</Option>
                            </Select>
                          </Tooltip>
                        </div>
                        <Tooltip
                          title={
                            selectedForCompare.length < 2
                              ? 'Select 2 hits to compare'
                              : `${
                                  !isCompared
                                    ? 'Click to compare'
                                    : 'Click to reset'
                                }`
                          }>
                          <Button
                            onClick={compareTwoHits}
                            disabled={selectedForCompare.length < 2}
                            icon={
                              isCompared ? <ClearOutlined /> : <ScanOutlined />
                            }>
                            {isCompared ? `Reset` : `Compare`}
                          </Button>
                        </Tooltip>
                        <Dropdown
                          overlay={takeActionMenu}
                          disabled={
                            alertDetails?.alertSourceId === '7' ||
                            alertDetails?.alertSourceId === '2'
                          }>
                          <Button type="primary" className={style.actionButton}>
                            <Space>
                              Take Action
                              <DownOutlined />
                            </Space>
                          </Button>
                        </Dropdown>
                      </div>
                    </div>
                    {filteredAlertDetails?.entities?.length && (
                      <div>
                        <NSAlertDetailPartyIdentity
                          GS={getGSConfig({
                            widgetGroupId:
                              identityAndhitsExplainabilityWidgetGroupId,
                            widgetId: identityWidgetId
                          })}
                          alertPartyIdentity={alertPartyIdentity?.data}
                          data={get(
                            filteredAlertDetails,
                            `entities.${entityIndex}`
                          )}
                        />
                        {get(
                          filteredAlertDetails,
                          `entities.${entityIndex}.hits`
                        ) && (
                          <div style={{ marginTop: '32px' }}>
                            <NSAlertDetailHits
                              GS={getGSConfig({
                                widgetGroupId:
                                  identityAndhitsExplainabilityWidgetGroupId,
                                widgetId: hitsExplainabilityWidgetId
                              })}
                              totalDiff={totalDiff}
                              data={get(
                                filteredAlertDetails,
                                `entities.${entityIndex}`
                              )}
                              apiActions={apiActions}
                              authentication={authentication}
                              selectedForCompare={selectedForCompare}
                              onSelectForComparision={onSelectForComparision}
                              hitsUserFeedback={hitsUserFeedback}
                              alertLevels={alertLevels}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className={style.noDataToDisplayWrapper}>
                    <NoDataToDisplay />
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

AlertDetail.propTypes = {
  apiActions: PropTypes.shape({
    navigateTo: PropTypes.func.isRequired,
    getNSGlobalSettingsPageInfo: PropTypes.func.isRequired,
    getAMLSCommonAlertPartyIdentity: PropTypes.func.isRequired,
    fetchAMLSAlertLevel: PropTypes.func.isRequired
  }).isRequired,
  settings: PropTypes.object,
  isEmbedded: PropTypes.bool,
  alertMetaPrefix: PropTypes.element,
  alertMetaSuffix: PropTypes.element,
  alertId: PropTypes.string,
  amlsCommon: PropTypes.object
};

export default AlertDetail;
